import { render, staticRenderFns } from "./UserPlanning.vue?vue&type=template&id=06617ea7"
import script from "./UserPlanning.vue?vue&type=script&lang=js"
export * from "./UserPlanning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports